/**
 * Creates a localStorage-backed state property with getter and setter.
 *
 * @param {string} stateKey - The key in the Vuex state object
 * @param {string} storageKey - Optional. The key in localStorage (defaults to stateKey)
 * @returns {object} Object with initial() and set methods
 *
 * @example
 * const refreshInterval = persistedState('callsRefreshInterval');
 *
 * export const state = {
 *   callsRefreshInterval: refreshInterval.initial(0),
 * };
 *
 * export const mutations = {
 *   setAutoRefreshInterval: refreshInterval.set,
 * };
 */
export const persistedState = (stateKey, storageKey = null) => {
  const key = storageKey || stateKey;

  return {
    /**
     * Get the initial value from localStorage
     * @param {*} defaultValue - Value to return if nothing in localStorage
     */
    initial: (defaultValue = null) => {
      const item = localStorage.getItem(key);
      return item == null || typeof item === 'undefined' ? defaultValue : JSON.parse(item);
    },

    /**
     * Mutation function that updates state and localStorage
     * @param {object} state - Vuex state object
     * @param {*} value - New value to set
     */
    set: (state, value) => {
      state[stateKey] = value;

      if (value == null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    },
  };
};
